import axios from "axios";

const api = axios.create({
  baseURL: "http://emailapi.scwmjt.com/api/", //正式地址
  // baseURL: "http://127.0.0.1:8100/api", //测试地址
  timeout: 30000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    const responseType = response.config.responseType;
    if (responseType === "blob" || responseType === "arraybuffer") {
      return response; // 完整返回response，包含data、headers、config等
    }

    // 普通接口请求：保持原有逻辑，直接返回response.data（兼容项目现有代码）
    return response.data;
  },
  (error) => {
    if (error.response) {
      // 如果后端返回了统一格式的错误响应
      if (error.response.data && error.response.data.message) {
        // 保持错误对象结构，让调用方可以访问 error.response.data
        return Promise.reject(error);
      }
      // 处理 401 未授权
      if (error.response.status === 401) {
        localStorage.removeItem("adminToken");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
